module.exports = __webpack_public_path__ + "static/media/slider-img5.07ee4e1c.jpg";